'use client';

import {styled} from '@mui/material/styles';
import {Typography} from '../primitives';

import {FIELD_PADDING_X} from './field-styles';

// Room inside the clip for Arabic descenders, which fall below the 1.2 line box.
const LABEL_PADDING_BLOCK = 4;

const Overlay = styled('span', {shouldForwardProp: p => p !== 'oAlign' && p !== 'oInsetStart'})<{
  oAlign: 'center' | 'top';
  oInsetStart: number;
}>(({theme, oAlign, oInsetStart}) => ({
  position: 'absolute',
  insetInlineStart: oInsetStart,
  top: oAlign === 'center' ? '50%' : 15 - LABEL_PADDING_BLOCK,
  paddingBlock: LABEL_PADDING_BLOCK,
  transform: oAlign === 'center' ? 'translateY(-50%)' : 'none',
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: `calc(100% - ${oInsetStart + FIELD_PADDING_X}px)`,
  color: theme.palette.colors.text.neutral.placeholder,
}));

const Asterisk = styled('span')(({theme}) => ({
  color: theme.palette.colors.text.error.default,
  marginInlineStart: theme.spacing(0.25),
}));

export interface FieldLabelProps {
  label: string;
  required?: boolean;
  align?: 'center' | 'top';
  insetStart?: number;
}

export function FieldLabel({label, required, align = 'center', insetStart = FIELD_PADDING_X}: FieldLabelProps) {
  return (
    <Overlay oAlign={align} oInsetStart={insetStart} aria-hidden>
      <Typography as="span" size="body-2" weight="regular" sx={{color: 'inherit'}}>
        {label}
        {required && <Asterisk>*</Asterisk>}
      </Typography>
    </Overlay>
  );
}

FieldLabel.displayName = 'FieldLabel';
